import { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Paper, Input, Tooltip, IconButton } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'

import Box from '@mui/material/Box'
import { themeV5 } from 'theme/v5'

const Search = ({ className, searchKey, onSearch, ...rest }) => {
  const field = useRef()

  const len = searchKey ? searchKey.length : 0
  const [searching, setSearching] = useState(len)
  const [value, setValue] = useState(searchKey)

  const onFocus = () =>
    field.current && field.current.focus()

  const onChange = useCallback(({ target }) => {
    const value = target?.value || ''
    setValue(value)
    onSearch(value.trim())
    setSearching(value.length)
  }, [onSearch, setSearching])

  useEffect(() => {
    setValue(len === 0 ? '' : searchKey)
    // eslint-disable-next-line
  }, [searchKey])

  const onClear = () => {
    setValue('')
    onSearch('')
  }

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        ...className
      }}
      {...rest} onClick={onFocus}>
      <Paper
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          height: 42,
          padding: '0px 16px',
          ...(searching && {
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: themeV5.palette.text.link,
          })
        }}
        elevation={1}>
        <Input
          sx={{
            flex: 1
          }}
          disableUnderline
          value={value}
          inputRef={field}
          placeholder="Search"
          onChange={onChange}/>
        {value.length > 0 && (
          <Tooltip title="clear search">
            <IconButton
              sx={{
                color: themeV5.palette.text.placeholder,
                '&:hover': {
                  backgroundColor: '#eeeeee !important',
                  cursor: 'pointer',
                }
              }}
              size="small" onClick={onClear}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        )}
        <SearchIcon
          sx={{
            marginRight: 2,
            color: themeV5.palette.text.placeholder
          }}/>
      </Paper>
    </Box>
  )
}

Search.propTypes = {
  className: PropTypes.string,
  searchKey: PropTypes.string,
  onSearch: PropTypes.func
}

export default Search
